import { render, staticRenderFns } from "./ConfirmChange.vue?vue&type=template&id=d28756cc&scoped=true&lang=pug"
import script from "./ConfirmChange.vue?vue&type=script&lang=js"
export * from "./ConfirmChange.vue?vue&type=script&lang=js"
import style0 from "./ConfirmChange.vue?vue&type=style&index=0&id=d28756cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28756cc",
  null
  
)

export default component.exports